import { render, staticRenderFns } from "./UserEditor.vue?vue&type=template&id=711195a4"
import script from "./UserEditor.vue?vue&type=script&lang=ts"
export * from "./UserEditor.vue?vue&type=script&lang=ts"
import style0 from "./UserEditor.vue?vue&type=style&index=0&id=711195a4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports